module.exports = __webpack_public_path__ + "static/img/zidongjieting2.9e55a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zidongjieting2.png
// module id = OtzO
// module chunks = 24